// 募集職種の地図

import { fadeIn, fadeOut } from '@pc/components/Fade'

function createGoogleMap() {
  const mapCoordinates = document.getElementById('js-detail-gmap-coordinates')
  const mapDisplay = document.querySelector<HTMLElement>('.js-detail-modal-gmap')

  if (mapCoordinates === null || mapDisplay === null) return
  if (mapCoordinates.dataset.lat === undefined || mapCoordinates.dataset.lon === undefined) return

  const lat = Number(mapCoordinates.dataset.lat)
  const lon = Number(mapCoordinates.dataset.lon)
  const position = new google.maps.LatLng(lat, lon)
  const options = {
    zoom: 18,
    center: position,
    mapId: google.maps.MapTypeId.ROADMAP
  }
  const map = new google.maps.Map(mapDisplay, options)
  void new google.maps.marker.AdvancedMarkerElement({ position, map })
}

export function map() {
  const detailModalMapOpen = document.querySelector<HTMLElement>('.js-modal-map-open')
  const detailModalClose = document.querySelector<HTMLElement>('.js-modal-close')
  const detailModal = document.querySelector<HTMLElement>('.js-modal')
  const detailModalDialog = document.querySelector<HTMLElement>('.js-detail-modal-dialog')

  if (detailModal === null) return

  detailModalMapOpen?.addEventListener(
    'click',
    () => {
      createGoogleMap()
    },
    { once: true }
  )
  detailModalMapOpen?.addEventListener('click', () => {
    fadeIn(detailModal)
  })
  detailModalClose?.addEventListener('click', () => {
    fadeOut(detailModal)
  })
  detailModal.addEventListener('click', () => {
    fadeOut(detailModal)
  })
  detailModalDialog?.addEventListener('click', (e) => {
    e.stopPropagation()
  })
}
